import { memo, useMemo } from 'react';

import Typography from '@material-ui/core/Typography';

import { MessageBadge } from '../messageBadge/MessageBadge';
import { ShadowDOM } from '../shadowDom/ShadowDom';
import { ListStyled, useStyles } from './PricingList.styles';
import { PricingListProps } from './PricingList.types';
import { PricingItem } from './pricingItem/PricingItem';

export const PricingList = memo(({ pricingsMap, adminFeeDisclaimer, brokerageFeeNotice }: PricingListProps) => {
  const styles = useStyles();

  const isPricingListEmpty = useMemo(() => !pricingsMap || Object.keys(pricingsMap).length === 0, [pricingsMap]);

  return (
    <div>
      {adminFeeDisclaimer && (
        <MessageBadge
          type="error"
          variant="outlined"
          roundedValue={0}
          message={
            <ShadowDOM htmlContent={adminFeeDisclaimer} component={<Typography variant="body1" color="inherit" />} />
          }
        />
      )}

      {brokerageFeeNotice && (
        <div style={{ marginTop: adminFeeDisclaimer ? 8 : 0 }}>
          <MessageBadge
            type="error"
            variant="outlined"
            roundedValue={0}
            message={
              <Typography variant="body1" color="inherit" style={{ fontWeight: 'bold' }}>
                {brokerageFeeNotice}
              </Typography>
            }
          />
        </div>
      )}

      {!isPricingListEmpty &&
        pricingsMap &&
        Object.entries(pricingsMap).map(([category, pricings], i) => (
          <div className={styles.categoryContainer} key={i}>
            <div>
              <Typography variant="h5">{category}</Typography>
            </div>

            <div>
              <ListStyled>
                {pricings.map((pricing, i) => (
                  <PricingItem pricingItem={{ id: pricing.id, name: pricing.name, price: pricing.price }} key={i} />
                ))}
              </ListStyled>
            </div>
          </div>
        ))}

      {isPricingListEmpty && (
        <div className={styles.noPricingContainer}>
          <Typography variant="h6">No Pricing Information Available</Typography>
        </div>
      )}
    </div>
  );
});
